<template>

    <div>
      jjjj
      <el-input
        v-model="value"
        :placeholder="column.placeholder ? column.placeholder : '请选择' + column.label">
        <!-- @focus="dialogVisible = true"> -->
        </el-input>
        <!-- <el-dialog
          :title="'请选择' + column.label"
          :visible.sync="dialogVisible"
          width="80%"
          :before-close="handleClose"
          :append-to-body="true" top="5vh">

          <selectCoordinate ref="selectCoordinate" @dataFill = "dataFill"/>

          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="confirm">确 定</el-button>
          </span>
        </el-dialog> -->
    </div>

</template>
<script>
// import Vue from 'vue'
// import selectCoordinate from './selectCoordinate'
import { deepClone } from '@/framework/util/util.js'
import mixinCustomEvent from '../customEvent'
// Vue.use(selectCoordinate)
export default {
  name: 'AvueWebMap',
  inject: ['viewFormData'],
  mixins: [mixinCustomEvent],
  // model: {
  //   prop: 'value',
  //   event: 'input'
  // },
  props: {
    column: {
      type: Object,
      default: () => {}
    },
    // 已经选择的对象
    value: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    // selectCoordinate
  },
  data() {
    return {
      dialogVisible: false,
      address: ''
    }
  },
  created() {
    // if (this.value) {
    //   this.address = this.value.address
    // }
  },
  methods: {
    dataFill(selectMap) {
      let xx = this.viewFormData
      debugger
      this.value = deepClone(selectMap)
      this.address = selectMap.address
    },
    confirm() {
      this.dialogVisible = false
      this.$refs.selectCoordinate.selectConfirm()
    }
  }
}
</script>
